import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICallResult, ICallResultState } from "./callresultModel";
import {
  CallResultActiveInactive,
  createCallResult,
  deleteCallResult,
  getAllActiveCallResult,
  getAllCallResult,
  getCallResultByID,
  updateCallResult,
} from "./services/callresult.service";

const initialState: ICallResultState = {
  loading: false,
  formLoading: false,
  error: "",
  CallResultList: [],
  CallResultID: null,
  CallResultDetail: {
    call_result: "",
    isactive: 1,
  },
};

const callresultSlice = createSlice({
  name: "callresult",
  initialState,
  reducers: {
    clearCallResultDetails: (state) => {
      state.CallResultDetail = initialState.CallResultDetail;
    },
    setCallResultID: (state, action) => {
      state.CallResultID = action.payload;
    },
    clearCallResultID: (state) => {
      state.CallResultID = initialState.CallResultID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCallResult.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCallResult.fulfilled,
      (state, action: PayloadAction<ICallResult[]>) => {
        state.loading = false;
        state.CallResultList = action.payload || [];
      }
    );
    builder.addCase(getAllCallResult.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CallResultList = [];
    });
    builder.addCase(getAllActiveCallResult.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCallResult.fulfilled,
      (state, action: PayloadAction<ICallResult[]>) => {
        state.loading = false;
        state.CallResultList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCallResult.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CallResultList = [];
    });
    builder.addCase(createCallResult.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createCallResult.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createCallResult.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCallResult.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateCallResult.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateCallResult.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCallResult.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCallResult.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCallResult.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(CallResultActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(CallResultActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(CallResultActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCallResultByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getCallResultByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.CallResultDetail = action.payload;
    });
    builder.addCase(getCallResultByID.rejected, (state, action) => {
      state.formLoading = false;
      state.CallResultDetail = initialState.CallResultDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCallResultDetails, setCallResultID, clearCallResultID } =
  callresultSlice.actions;
export default callresultSlice.reducer;
